import { ReactElement } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import MUITable from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IPagination } from '~/utils/pagination';
import Loader from '~/ui/components/common/Loader';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import { IPagePermissions } from '../../../types';
import styles from './Table.module.scss';
import Item from './Item';
import { ITriageRequestList } from '~/services/api/triage/types';
import { IBloodPressureReading } from '~/services/api/readings/types';

interface IProps {
  requests: ITriageRequestList[];
  permissions: IPagePermissions;
  programId: number;
  onLoadMore: () => void;
  pagination: IPagination;
  setSelectedNoteId: (id: number) => void;
  onBloodPressureUpdated: (data: IBloodPressureReading) => void;
}

const Table = ({
  requests,
  permissions,
  programId,
  onLoadMore,
  pagination,
  setSelectedNoteId,
  onBloodPressureUpdated,
}: IProps): ReactElement => (
  <TableContainer className={styles.tableContainer} id="scrollableDiv">
    <InfiniteScroll
      next={onLoadMore}
      hasMore={pagination.hasMore}
      loader={<Loader />}
      dataLength={requests.length}
      scrollableTarget="scrollableDiv"
    >
      <MUITable>
        <TableHead>
          <TableRow>
            {programId === null && <TableCell>Program</TableCell>}
            <TableCell>Patient</TableCell>
            <TableCell>Issue</TableCell>
            <TableCell>Date</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.length > 0 ? (
            requests.map(request => (
              <Item
                key={request.noteId}
                request={request}
                permissions={permissions}
                programId={programId}
                setSelectedNoteId={setSelectedNoteId}
                onBloodPressureUpdated={onBloodPressureUpdated}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={programId === null ? 5 : 4}>
                <NoDataFound />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </MUITable>
    </InfiniteScroll>
  </TableContainer>
);

export default Table;
